// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Portugal from '../_raw/flag/icon_flag_portugal.png';

export default () => <img src={Portugal} alt="Portugal" />;
